<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="520px"
    custom-class="joint-cooperation-dialog"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <div slot="title" class="dialog-title-wrap">
      <span class="title-bar" />
      <span class="title-text">新增联营合作</span>
    </div>

    <div v-loading="loading" class="dialog-body">
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-position="top"
        size="small"
      >
        <el-form-item label="法人姓名" prop="saLegalName">
          <el-input
            v-model.trim="formData.saLegalName"
            placeholder="请输入"
            maxlength="50"
            :disabled="disableSaLegalForm"
          />
        </el-form-item>
        <el-form-item label="法人手机号" prop="saLegalMobile">
          <el-input
            v-model.trim="formData.saLegalMobile"
            placeholder="请输入"
            maxlength="11"
            :disabled="disableSaLegalForm"
          />
        </el-form-item>
        <el-form-item label="营业执照名称" prop="licenseName">
          <el-input
            v-model.trim="formData.licenseName"
            placeholder="请输入"
            maxlength="100"
            :disabled="disableSaLegalForm"
          />
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="licenseCreditCode">
          <el-input
            v-model.trim="formData.licenseCreditCode"
            placeholder="请输入"
            maxlength="30"
            :disabled="disableSaLegalForm"
          />
        </el-form-item>
        <el-form-item label="服务费率" prop="serviceFeeRate">
          <el-input
            :value="formData.serviceFeeRate"
            placeholder="请输入"
            @input="onRateInput"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer-center">
      <el-button size="small" @click="innerVisible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="onSubmit">
        提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getStoreEditDetailAPI, addStoreJointCooperationAPI } from "../api";

const MOBILE_PATTERN = /^1[3-9]\d{9}$/;

export default {
  name: "StoreJointCooperationDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    storeId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      submitting: false,
      /** 大订单结算进件中/成功时，资质字段不可改（与门店编辑页一致） */
      alipaySubMerchantStatus: 0,
      formData: {
        saLegalName: "",
        saLegalMobile: "",
        licenseName: "",
        licenseCreditCode: "",
        serviceFeeRate: "",
      },
      formRules: {
        saLegalName: [{ required: true, message: "请输入法人姓名", trigger: "blur" }],
        saLegalMobile: [
          { required: true, message: "请输入法人手机号", trigger: "blur" },
          {
            pattern: MOBILE_PATTERN,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        licenseName: [{ required: true, message: "请输入营业执照名称", trigger: "blur" }],
        licenseCreditCode: [
          { required: true, message: "请输入统一社会信用代码", trigger: "blur" },
        ],
        serviceFeeRate: [
          { required: true, message: "请输入服务费率", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!/^(10|[0-9])$/.test(String(value || ""))) {
                callback(new Error("请输入0-10之间的整数"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    disableSaLegalForm() {
      return (
        this.alipaySubMerchantStatus === 1 || this.alipaySubMerchantStatus === 2
      );
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        if (val && this.storeId) {
          this.loadStoreDetail();
        }
      },
    },
    innerVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    async loadStoreDetail() {
      this.loading = true;
      try {
        const detail = await getStoreEditDetailAPI(this.storeId);
        this.alipaySubMerchantStatus = detail.alipaySubMerchantStatus || 0;
        this.formData = {
          saLegalName: detail.saLegalName || "",
          saLegalMobile: detail.saLegalMobile || "",
          licenseName: detail.licenseName || "",
          licenseCreditCode: detail.licenseCreditCode || "",
          serviceFeeRate: "",
        };
        this.$nextTick(() => {
          this.$refs.formRef?.clearValidate();
        });
      } finally {
        this.loading = false;
      }
    },
    onRateInput(value) {
      const digitText = String(value || "").replace(/\D/g, "");
      if (!digitText) {
        this.formData.serviceFeeRate = "";
        return;
      }
      let n = parseInt(digitText, 10);
      if (Number.isNaN(n)) {
        this.formData.serviceFeeRate = "";
        return;
      }
      if (n > 10) n = 10;
      if (n < 0) n = 0;
      this.formData.serviceFeeRate = String(n);
    },
    onClose() {
      this.$refs.formRef?.resetFields();
      this.alipaySubMerchantStatus = 0;
      this.formData = {
        saLegalName: "",
        saLegalMobile: "",
        licenseName: "",
        licenseCreditCode: "",
        serviceFeeRate: "",
      };
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.submitting = true;
        try {
          await addStoreJointCooperationAPI({
            storeId: Number(this.storeId),
            saLegalName: this.formData.saLegalName,
            saLegalMobile: this.formData.saLegalMobile,
            licenseName: this.formData.licenseName,
            licenseCreditCode: this.formData.licenseCreditCode,
            serviceRate: Number(this.formData.serviceFeeRate),
          });
          this.$message.success("提交成功");
          this.innerVisible = false;
          this.$emit("success");
        } catch (e) {
          const msg =
            e?.data?.message ||
            e?.response?.data?.message ||
            e?.message ||
            "提交失败";
          this.$message.error(msg);
        } finally {
          this.submitting = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-bar {
  width: 4px;
  height: 18px;
  background: #409eff;
  border-radius: 2px;
  flex-shrink: 0;
}

.title-text {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.dialog-body {
  min-height: 80px;
}

.dialog-footer-center {
  text-align: center;
}
</style>

<style lang="scss">
.joint-cooperation-dialog {
  .el-dialog__header {
    padding: 20px 20px 10px;
  }
  .el-dialog__body {
    padding: 10px 24px 0;
  }
  .el-dialog__footer {
    padding: 10px 20px 20px;
  }
}
</style>
